import * as TYPES from './type';
export default {
  //授课问卷
  [TYPES.SK_INQUIRY_LIST](state, { result }) {
    state.SKInquiryList = result.result
  },
  //问卷详情
  [TYPES.SK_INQUIRY_DETAILS](state, { result }) {
    state.SKInquiryDetails = result.result
  },
  //授课编辑
  [TYPES.SK_INQUIRY_EDIT](state, { result }) {
    state.SKInquiryEdit = result.result
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/inquiry/mutations.js